import React from "react";

export const DropDownInputComponent = ({
  value,
  changeValue,
  name,
  id,
  required = false,
  data,
  selectBy,
}) => {
  return (
    <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
      <label htmlFor={id} className="font-medium">
        {name}
      </label>
      {required ? <label className="text-[red] pl-1">*</label> : <></>}
      <div className="mt-4">
        <select
          id={id}
          required={required}
          onChange={(e) => changeValue(e.target.value)}
          value={value}
          className=" w-4/5 sm:w-3/5  border-[1px] px-3 py-2 rounded-md border-gray-300 outline-none transition-all duration-300 hover:bg-gray-100 focus:border-[#1976D2] focus:border-b-2"
        >
          <option value={""}>--Please Select--</option>
          {data.map((item, index) => {
            return (
              <option key={index} value={item[selectBy]}>
                {item[selectBy]}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};
